// 4Throws header mega menu (t4h) — behavior ported from the QA'd prototype.
// Desktop: hover/click opens the panel anchored to .header-wrapper; Esc/focus-out close.
// Mobile: burger opens the drawer; sections are native <details>.
(function () {
  // Root selection: in static mode the snippet's <t4h-header> holds nav + panels.
  // In block mode the panels are rendered by section-level theme blocks OUTSIDE
  // the snippet's <t4h-header> (directly under the .header.t4h element), so the
  // desktop root must be the innermost .t4h ancestor that contains BOTH the nav
  // items and the panels; static-mode behavior stays identical (single root).
  var roots = Array.prototype.slice.call(document.querySelectorAll('.t4h'));
  if (!roots.length) return;
  var navRoot = null, shellRoot = null;
  for (var r = roots.length - 1; r >= 0; r--) {
    if (!navRoot && roots[r].querySelector('.t4h-item') && roots[r].querySelector('.t4h-panel')) navRoot = roots[r];
  }
  for (var s = 0; s < roots.length; s++) {
    if (!shellRoot && roots[s].querySelector('.t4h-burger')) shellRoot = roots[s];
  }
  var root = navRoot || shellRoot;
  if (!root) return;

  var setClosedFns = []; // declared at IIFE scope - the esc handler may run regardless of drawer presence

  var items = navRoot ? Array.prototype.slice.call(navRoot.querySelectorAll('.t4h-item')) : [];
  var panels = navRoot ? Array.prototype.slice.call(navRoot.querySelectorAll('.t4h-panel')) : [];
  if (items.length && panels.length) {
    var mq = matchMedia('(min-width: 1056px)');
    var openKey = null;

    var setOpen = function (key) {
      openKey = key;
      items.forEach(function (it) {
        var on = it.getAttribute('data-menu') === key;
        if (on) it.setAttribute('data-open', ''); else it.removeAttribute('data-open');
        var b = it.querySelector('.t4h-btn');
        if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var owner = p.id.replace('t4h-panel-', '');
        if (openKey && owner === openKey) p.setAttribute('data-shown', '');
        else p.removeAttribute('data-shown');
      });
    };

    items.forEach(function (it) {
      var key = it.getAttribute('data-menu');
      var btn = it.querySelector('.t4h-btn');
      if (!btn) return;
      btn.addEventListener('click', function () { if (!mq.matches) return; setOpen(openKey === key ? null : key); });
      it.addEventListener('pointerenter', function (e) {
        if (mq.matches && e.pointerType === 'mouse') setOpen(key);
      });
    });

    root.addEventListener('pointerleave', function (e) {
      if (mq.matches && e.pointerType === 'mouse') setOpen(null);
    });
    root.addEventListener('focusout', function (e) {
      if (openKey && !root.contains(e.relatedTarget)) setOpen(null);
    });
    panels.forEach(function (p) {
      p.addEventListener('click', function (e) {
        if (e.target.closest('a')) setOpen(null);
      });
    });
    if (mq.addEventListener) mq.addEventListener('change', function () { if (!mq.matches) setOpen(null); });
  }

  // ---- block-rendered drawer fragments ----
  // In block mode (header section blocks seeded) the t4h-panel blocks emit their
  // accordion fragments inline next to the desktop panels. Adopt them into the
  // drawer nav before the CTA so the block-rendered sections fill the drawer;
  // the fragments keep their .t4h-acc classes so all existing binding works.
  (function () {
    var drawerNav = document.querySelector('#t4h-drawer .t4h-drawer-nav');
    var drawerCta = document.querySelector('.t4h-drawer-cta');
    if (!drawerNav || !drawerCta) return;
    var frags = document.querySelectorAll('.t4h-acc-block');
    for (var i = 0; i < frags.length; i++) {
      if (frags[i].closest('#t4h-drawer')) continue;
      drawerNav.insertBefore(frags[i], drawerCta);
    }
  })();

  // ---- mobile drawer ----
  // Dawn's sticky wrapper carries will-change:transform, which makes it the
  // containing block for fixed descendants (the drawer collapses to the bar's
  // own box). Adopt the drawer + scrim onto <body> so position:fixed anchors
  // to the viewport, and keep their z-index above the header wrapper (90).
  var drawerRoot = shellRoot || root;
  var burger = drawerRoot.querySelector('.t4h-burger');
  var drawer = document.getElementById('t4h-drawer');
  if (drawer && drawer.parentElement !== document.body) {
    drawer.classList.add('t4h'); // self-styling root after adoption
    document.body.appendChild(drawer);
  }
  var scrim = drawer ? document.querySelector('.t4h-scrim') : null;
  if (scrim && scrim.parentElement !== document.body) {
    scrim.classList.add('t4h');
    document.body.appendChild(scrim);
  }
  var drawerClose = drawer ? drawer.querySelector('.t4h-drawer-close') : null;
  if (burger && drawer && scrim && drawerClose) {
    var setDrawer = function (on) {
      if (on) drawer.setAttribute('data-open', ''); else drawer.removeAttribute('data-open');
      if (on) drawer.removeAttribute('aria-hidden'); else drawer.setAttribute('aria-hidden', 'true');
      if (on) scrim.setAttribute('data-open', ''); else scrim.removeAttribute('data-open');
      burger.setAttribute('aria-expanded', on ? 'true' : 'false');
      document.body.style.overflow = on ? 'hidden' : '';
      if (!on) {
        var open = drawer.querySelectorAll('details[open]');
        for (var i = 0; i < open.length; i++) open[i].removeAttribute('open');
      }
    };
    burger.addEventListener('click', function () { setDrawer(true); });
    drawerClose.addEventListener('click', function () { setDrawer(false); });
    scrim.addEventListener('click', function () { setDrawer(false); });
    var links = drawer.querySelectorAll('a');
    for (var j = 0; j < links.length; j++) {
      links[j].addEventListener('click', function () { setDrawer(false); });
    }
    setClosedFns.push(function () { setDrawer(false); });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    for (var k = 0; k < setClosedFns.length; k++) setClosedFns[k]();
    // close any open desktop panel too (aria states reset with the attributes)
    var openPanels = root.querySelectorAll('.t4h-panel[data-shown]');
    for (var m = 0; m < openPanels.length; m++) openPanels[m].removeAttribute('data-shown');
    var openItems = root.querySelectorAll('.t4h-item[data-open]');
    for (var n = 0; n < openItems.length; n++) {
      openItems[n].removeAttribute('data-open');
      var b = openItems[n].querySelector('.t4h-btn');
      if (b) b.setAttribute('aria-expanded', 'false');
    }
  });
})();